// extracted by mini-css-extract-plugin
export default {"formik-red-color":"LabelFieldFormik_formik-red-color__x+7fH"};